import * as React     from 'react';
import { useHistory } from 'react-router-dom';
import * as PropTypes from 'prop-types';

const SearchPageItem = function(props) {
  const {
          handleSearchClose,
          label,
          urlKey
        } = props;

  const history = useHistory();

  const handleContainerClick = React.useCallback((event) => {
    event.stopPropagation();

    if (!event.target.closest('a')) {
      history.replace(urlKey);

      handleSearchClose();
    }
  }, [handleSearchClose, history]);

  return (
    <div
      onClick={handleContainerClick}
      className={'item new inline'}
    >
      <div className={'questions_wrapper'}>
        <div className={'title'}>
          {label}
        </div>
      </div>
    </div>
  );
};

SearchPageItem.propTypes = {
  handleSearchClose: PropTypes.func,
  label:             PropTypes.string.isRequired,
  urlKey:            PropTypes.string.isRequired
};

export default SearchPageItem;